/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * 資料フォルダ
 * @export
 * @interface DocumentFolder
 */
export interface DocumentFolder {
  /**
   *
   * @type {string}
   * @memberof DocumentFolder
   */
  id: string
  /**
   * フォルダ名
   * @type {string}
   * @memberof DocumentFolder
   */
  name: string
  /**
   * フォルダ内の資料数
   * @type {number}
   * @memberof DocumentFolder
   */
  documentsCount: number
  /**
   *
   * @type {string}
   * @memberof DocumentFolder
   */
  createdAt: string
  /**
   *
   * @type {string}
   * @memberof DocumentFolder
   */
  updatedAt: string
}

export function DocumentFolderFromJSON(json: any): DocumentFolder {
  return DocumentFolderFromJSONTyped(json, false)
}

export function DocumentFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentFolder {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    documentsCount: json['documents_count'],
    createdAt: json['created_at'],
    updatedAt: json['updated_at']
  }
}

export function DocumentFolderToJSON(value?: DocumentFolder | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    name: value.name,
    documents_count: value.documentsCount,
    created_at: value.createdAt,
    updated_at: value.updatedAt
  }
}
